/* Supplement World — site-wide JS (header cart trigger, mobile nav) */
(function () {
  'use strict';

  // Open cart from header icon (if cart drawer snippet is on page)
  if (typeof window.openCart !== 'function') {
    window.openCart = function () {
      const o = document.getElementById('cartOverlay');
      const p = document.getElementById('cartPanel');
      if (o && p) {
        o.classList.add('open');
        p.classList.add('open');
        document.body.style.overflow = 'hidden';
      } else {
        // Fallback: go to the cart page if drawer isn't on this page
        window.location.href = '/cart';
      }
    };
  }
  if (typeof window.closeCart !== 'function') {
    window.closeCart = function () {
      document.getElementById('cartOverlay')?.classList.remove('open');
      document.getElementById('cartPanel')?.classList.remove('open');
      document.body.style.overflow = '';
    };
  }

  // Mobile nav drawer
  window.openMobileNav = function () {
    document.getElementById('mobileNavOverlay')?.classList.add('open');
    document.getElementById('mobileNavPanel')?.classList.add('open');
    document.body.style.overflow = 'hidden';
  };
  window.closeMobileNav = function () {
    document.getElementById('mobileNavOverlay')?.classList.remove('open');
    document.getElementById('mobileNavPanel')?.classList.remove('open');
    document.body.style.overflow = '';
  };

  // Mobile collection filter drawer + grid/list toggle
  window.openMobileFilters = function () {
    document.getElementById('mobileFiltersOverlay')?.classList.add('open');
    document.getElementById('mobileFiltersPanel')?.classList.add('open');
    document.body.style.overflow = 'hidden';
  };
  window.closeMobileFilters = function () {
    document.getElementById('mobileFiltersOverlay')?.classList.remove('open');
    document.getElementById('mobileFiltersPanel')?.classList.remove('open');
    document.body.style.overflow = '';
  };
  window.setGridLayout = function (mode) {
    const grid = document.querySelector('.products-grid');
    if (!grid) return;
    grid.classList.toggle('products-grid-single', mode === 'single');
    document.querySelectorAll('.layout-toggle-btn').forEach(b => b.classList.toggle('active', b.dataset.layout === mode));
    try { localStorage.setItem('sw_grid_mode', mode); } catch (e) {}
  };

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') { window.closeCart(); window.closeMobileNav(); window.closeMobileFilters(); }
  });

  // Restore saved grid mode
  try {
    const saved = localStorage.getItem('sw_grid_mode');
    if (saved) document.addEventListener('DOMContentLoaded', () => window.setGridLayout(saved));
  } catch (e) {}
})();
